import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {GameInfoModuleConfig} from "./game-info-module.config";
import {GameInfoModuleState} from "./models/game-info-module.state";

export class GameInfoModuleStore extends BaseMobxStore {
  static injectables = [GameInfoModuleConfig, GameInfoModuleState];
}
